import { AKA } from '../types';
export default {
  type: AKA,
  service: 'remote.akroma.io',
  url: 'https://remote.akroma.io',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
